import { RefreshTokenErrorMessage } from "configs";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { loadRefreshToken, saveAccessToken, saveRefreshToken } from "utils";

import Paths from "./paths";
import {
  AuthGetMeResponse,
  AuthPermissionsRequest,
  AuthPermissionsResponse,
  AuthRefreshTokenRequest,
  AuthRefreshTokenResponse,
  AuthSignInRequest,
  AuthSignInResponse,
} from "./types";

export const authSignInService = (params: AuthSignInRequest) =>
  RestAPIClient.call<AuthSignInResponse>({
    method: HTTPRequestMethods.POST,
    url: Paths.SignIn,
    data: params,
  });

export const authGetMeService = () =>
  RestAPIClient.call<AuthGetMeResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.GetMe,
    config: {
      requireAuthentication: true,
    },
  });

export const authRefreshTokenService = (params: AuthRefreshTokenRequest) =>
  RestAPIClient.call<AuthRefreshTokenResponse>({
    method: HTTPRequestMethods.POST,
    url: Paths.RefreshToken,
    data: params,
    config: { requireAuthentication: true },
  });

export const authRefreshTokenHandler = () => {
  return new Promise<{ accessToken?: string }>((resolve, rejects) => {
    const refreshToken = loadRefreshToken();
    if (!refreshToken) throw new Error(RefreshTokenErrorMessage);
    authRefreshTokenService({ refreshToken })
      .then((res) => {
        const { accessToken: newAccessToken, refreshToken: newRefreshToken } =
          res?.data || {};
        if (!newAccessToken) return rejects;
        saveRefreshToken(newRefreshToken || refreshToken);
        saveAccessToken(newAccessToken);
        return resolve({ accessToken: newAccessToken });
      })
      .catch((error) => rejects(error));
  });
};

export const authPermissionsService = (params?: AuthPermissionsRequest) =>
  RestAPIClient.call<AuthPermissionsResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.Permissions,
    config: {
      requireAuthentication: true,
      headers: { "x-application": params?.applicationCode || null },
    },
  });
